import React, { useState, useEffect } from "react";
import { TableBuilder, TableBuilderColumn } from "baseui/table-semantic";
import { useHistory, useParams } from "react-router-dom";
import { connect } from "react-redux";

import LoadingOverlay from "../../components/loading-overlay/LoadingOverlayComponent";
import { MODELRUN_ROW_MENU_ACTIONS } from "../../constants/AppEnums";
import { format, set } from "date-fns";
import { Button, SHAPE, SIZE as BSIZE, KIND } from "baseui/button";
import Overflow from "baseui/icon/overflow";
import { StatefulMenu } from "baseui/menu";
import { StatefulPopover, PLACEMENT } from "baseui/popover";
import { Tag, SIZE as TSIZE, VARIANT } from "baseui/tag";
import { Block } from "baseui/block";
import { MODELRUN_ROW_MENU_ITEMS } from "../../constants/AppEnums";
import {
  MODELRUNTASK_TABLE_ID,
  MODELRUNTASK_TABLE_STATUS,
  MODELRUNTASK_TABLE_CREATEDDATE,
  MODELRUNTASK_TABLE_DESIRED_STATUS,
  COMPUTE_INSTANCE_TYPE_LIST,
} from "../../constants/ModelersConstants";
import useToaster from "../../hooks/useToaster";
import { FaCloudDownloadAlt } from "react-icons/fa"; // Add FaTrash for delete button
import useFileDownloader from "../../hooks/useFileDownloader";
import { Spinner } from "baseui/icon";
import useRouteParams from "../../hooks/useRouteParams";
import {
  LabelMedium,
  LabelSmall,
  LabelXSmall,
  ParagraphSmall,
  ParagraphXSmall,
} from "baseui/typography";
import { Pagination } from "baseui/pagination";
import { styled } from "baseui";
import { FlexGrid, FlexGridItem } from "baseui/flex-grid";
import { useTranslation } from "react-i18next";
import { Select, SIZE as SSIZE } from "baseui/select";
import { FormControl } from "baseui/form-control";
import { Radio, ALIGN } from "baseui/radio";
import PremiumLock from "../../components/premium-lock/PremiumLockComponent";
import {
  executeModelRun,
  fetchModelRunTasks,
  terminateModelRunTask,
} from "../../redux/model-run/ModelRunThunk";
import PaginatedTable from "../../components/paginated-table/PaginatedTable";
const TableAndPaginationContainer = styled("div", {
  maxWidth: "1000px", // Increase the maxWidth of the parent container
  display: "flex",
  minHeight: "40vh", // This ensures that the container has a minimum height
  margin: "0 auto",
  overflow: "hidden",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between", // Pushes the footer to the bottom
  padding: "0 24px",
});

const HeadearArea = styled(FlexGridItem, ({ $theme }) => ({
  height: "60px",
  padding: " 0px 50px",
  borderBottom: `${$theme.colors.primary} solid`,
}));
const MiddleArea = styled(FlexGridItem, ({ $theme }) => ({
  borderBottom: `${$theme.colors.primary} solid`,
  overflow: "auto",
  height: "calc(40vh - 100px)",
}));

function statusToTagKind(status) {
  switch (status) {
    case "PENDING": {
      return "warning";
    }
    case "SUCCEEDED": {
      return "positive";
    }
    case "SUBMITTED": {
      return "warning";
    }
    case "DEPROVISIONING": {
      return "warning";
    }
    case "PROVISIONING": {
      return "warning";
    }
    case "FAILED": {
      return "negative";
    }
    case "STOPPED": {
      return "positive";
    }
    case "RUNNING": {
      return "positive";
    }
    default: {
      return "neutral";
    }
  }
}

function NameCell({ name }) {
  return <LabelXSmall>{name}</LabelXSmall>;
}

function StatusCell({ status }) {
  return (
    <Block>
      <Tag
        size={TSIZE.smal}
        closeable={false}
        variant={VARIANT.solid}
        kind={statusToTagKind(status)}
      >
        {status}
      </Tag>
    </Block>
  );
}

function DateCell({ date }) {
  return (
    <LabelXSmall>
      {date ?? format(new Date(date), "yyyy-MM-dd - HH:mm:ss")}
    </LabelXSmall>
  );
}

function DownloadCell({ generated, modelerId, modelRunId }) {
  const [downloadFile, loading] = useFileDownloader();
  return (
    <Button
      size={BSIZE.mini}
      disabled={!generated}
      startEnhancer={() =>
        loading ? <Spinner></Spinner> : <FaCloudDownloadAlt size={20} />
      }
      shape={SHAPE.pill}
      // onClick={() => {
      //   downloadFile("modeler", `${modelerId}/${modelRunId}.zip`);
      // }}
    >
      {" "}
      Download{" "}
    </Button>
  );
}
const PAGE_SIZE = 5;

function ModelerRunExecutions(props) {
  const { _, searchParams, searchPart } = useRouteParams();
  const { modelerId } = useParams();
  const [computeSize, setComputeSize] = useState([
    COMPUTE_INSTANCE_TYPE_LIST[0],
  ]);
  const [selectedExecution, setSelectedExecution] = useState(null);
  const [refreshTable, setRefreshTable] = useState(false);
  const { t } = useTranslation("modeler");

  useToaster(props.modelRun.fetchErrorMessage);
  useToaster(props.modelRun.executeErrorMessage);

  useEffect(() => {
    if (searchParams["runId"]) {
      props.onFetchModelRunTasks(
        modelerId,
        searchParams["runId"],
        PAGE_SIZE,
        null
      );
    }
  }, []);

  const handleExecuteModelRun = () => {
    props.onExecuteModelRun(
      modelerId,
      searchParams["runId"],
      computeSize[0].id,
      props.activeModeler?.solver
    );
  };

  const handleFetchModelRunTasks = (token) => {
    setSelectedExecution(null);
    setRefreshTable(false);
    props.onFetchModelRunTasks(
      modelerId,
      searchParams["runId"],
      PAGE_SIZE,
      token
    );
  };
  const handleRefresh = () => {
    setRefreshTable(true);
    props.onFetchModelRunTasks(
      modelerId,
      searchParams["runId"],
      PAGE_SIZE,
      null
    );
  };

  const handleTerminateModelRun = () => {
    if (!selectedExecution || !selectedExecution.id) {
      return;
    }
    props.onTerminateModelRun(
      modelerId,
      searchParams["runId"],
      selectedExecution.id
    );
  };
  if (props.user?.subscription?.plan !== "PREMIUM") {
    return <PremiumLock />;
  }
  const columns = [
    {
      header: "  ",
      cell: (row) => (
        <Radio
          value={row.id}
          checked={selectedExecution?.id === row.id}
          onChange={() => setSelectedExecution(row)}
          align={ALIGN.right}
        />
      ),
    },
    {
      header: "Id",
      cell: (row) => <NameCell name={row[MODELRUNTASK_TABLE_ID]} />,
    },
    {
      header: "Status",
      cell: (row) => <StatusCell status={row[MODELRUNTASK_TABLE_STATUS]} />,
    },
    {
      header: "Desired Status",
      cell: (row) => (
        <StatusCell status={row[MODELRUNTASK_TABLE_DESIRED_STATUS]} />
      ),
    },
    {
      header: "Created Date",
      cell: (row) => <DateCell date={row[MODELRUNTASK_TABLE_CREATEDDATE]} />,
    },
    {
      header: " ",
      cell: (row) => (
        <DownloadCell
          generated={row.generated}
          modelerId={modelerId}
          modelRunId={row.id}
        />
      ),
    },
  ];

  return (
    <Block>
      <LoadingOverlay isLoading={props.fetchInProgress} />
      <HeadearArea>
        <Block display="flex" justifyContent="space-between">
          <Block display="flex" justifyContent="space-between" width="250px">
            <Button
              disabled={
                !selectedExecution ||
                !selectedExecution.id ||
                selectedExecution.desiredStatus === "COMPLETED" ||
                selectedExecution.desiredStatus === "STOPPED" ||
                selectedExecution.desiredStatus === "FAILED"
              }
              isLoading={props.modelRun?.terminateInProgress}
              size={BSIZE.mini}
              onClick={handleTerminateModelRun}
            >
              {t("terminateButton")}
            </Button>

            <Button
              disabled={
                !searchParams?.runId || !props.selectedModelRun?.generated
              }
              isLoading={props.modelRun?.executeInProgress}
              size={BSIZE.mini}
              onClick={handleExecuteModelRun}
            >
              {t("executeButton")}
            </Button>
            <Button
              disabled={!searchParams?.runId}
              size={BSIZE.mini}
              onClick={handleRefresh}
            >
              {" "}
              {t("modelRunExecuteRefresh")}{" "}
            </Button>
          </Block>

          <Block width={"200px"}>
            <Select
              disabled={
                !searchParams?.runId || !props.selectedModelRun?.generated
              }
              overrides={{
                ControlContainer: {
                  style: {
                    width: "200px",
                    marginLeft: "10px",
                    padding: "0px",
                  },
                },

                DropdownListItem: {
                  // This assumes the name of the dropdown list items can be targeted like this
                  style: ({ $theme }) => ({
                    textAlign: "center", // Centers the text within each dropdown item
                  }),
                },
                Popover: {
                  // Assuming the dropdown uses a popover or similar component
                  style: {
                    textAlign: "center", // Centers the dropdown list within the popover
                  },
                },
              }}
              size={SSIZE.mini}
              options={COMPUTE_INSTANCE_TYPE_LIST}
              value={computeSize}
              clearable={false}
              searchable={false}
              onChange={(params) => setComputeSize(params.value)}
              placeholder={""}
            ></Select>
          </Block>
        </Block>
      </HeadearArea>
      <MiddleArea>
        <Block
          display="flex"
          flexDirection="column"
          justifyContent="center"
          padding="scale500"
          width="100%" // Ensure the block takes full width available
          $style={{ wordWrap: "break-word" }} // Breaks words to prevent overflow
        >
          {" "}
          {selectedExecution?.logs ? (
            (selectedExecution?.logs || []).map((log, index) => (
              <ParagraphXSmall key={index} margin="scale300">
                {log}
              </ParagraphXSmall>
            ))
          ) : (
            <LabelMedium>No logs available</LabelMedium>
          )}
        </Block>
      </MiddleArea>
      <TableAndPaginationContainer>
        <PaginatedTable
          data={props.tasks}
          columns={columns}
          nextToken={props.nextToken}
          onNext={handleFetchModelRunTasks}
          onPrev={handleFetchModelRunTasks}
          refresh={refreshTable}
        />
      </TableAndPaginationContainer>
    </Block>
  );
}
const mapStateToProps = (state) => {
  return {
    user: state.user,
    activeModeler: state.modeler.activeModeler,
    modelRun: state.modelRun,
    tasks: state.modelRun?.tasks || [],
    selectedModelRun: state.modelRun.selectedModelRun,
    fetchInProgress: state.modelRun.fetchModelRunTasksInProgress,
    fetchError: state.modelRun.fetchModelRunTasksError,
    fetchErrorMessage: state.modelRun.fetchModelRunTasksErrorMessage,
    nextToken: state.modelRun?.tasksNextToken,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onExecuteModelRun: (modelerId, modelRunId, computeSize, solver) => {
      dispatch(executeModelRun(modelerId, modelRunId, computeSize, solver));
    },
    onFetchModelRunTasks: (modelerId, modelRunId, page_size, nextToken) => {
      dispatch(fetchModelRunTasks(modelerId, modelRunId, page_size, nextToken));
    },
    onTerminateModelRun: (modelerId, modelRunId, taskId) => {
      dispatch(terminateModelRunTask(modelerId, modelRunId, taskId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModelerRunExecutions);
